import {
  Button,
  createStyles,
  Grid,
  makeStyles,
  Theme
} from "@material-ui/core";
import React from "react";

interface ChatTextAreaInterface {
  textValue: string;
  handleTextChange: (e: any) => any;
  handleSubmitClicked: (e: any) => any;
}

export const useNotesStyles = makeStyles((theme: Theme) =>
  createStyles({
    textAreaDiscussionWrapper: {
      marginLeft: 36,
      height: "89px",
      border: "1px solid #cad1d7",
      borderRadius: "4px",
      marginTop: "1.5%",
      "&:disabled": {
        cursor: "no-drop"
      }
    },
    CssTextarea: {
      fontFamily: "'Open Sans', sans-serif !important",
      border: "none",
      width: "100%",
      reSize: "both",
      padding: "14px 12px 14px 12px",
      "border-radius": "4px",
      outline: "none",
      boxSizing: "border-box",
      fontSize: "14px",
      height: "100%",
      background: "transparent",
      "&:disabled": {
        cursor: "no-drop"
      }
    },
    sendButton: {
      marginLeft: 36
    },
    charRemaining: {
      justifyItems: "flex-end",
      justifyContent: "flex-end",
      fontWeight: 500,
      fontSize: 12
    }
  })
);

export const ChatTextArea = ({
  textValue,
  handleTextChange,
  handleSubmitClicked
}: ChatTextAreaInterface) => {
  const classesNotes = useNotesStyles();
  return (
    <>
      <Grid
        item
        className={classesNotes.textAreaDiscussionWrapper}
        style={{ marginTop: "0%" }}
      >
        <textarea
          className={classesNotes.CssTextarea}
          name="comment-text"
          value={textValue}
          data-testid="chat-field"
          maxLength={1000}
          onChange={(e: any) => {
            handleTextChange(e.target.value);
          }}
        />
      </Grid>
      <Grid item container xs={12} className={classesNotes.charRemaining}>
        <p>Characters remaining : {1000 - textValue.trim().length}</p>
      </Grid>
      <Button
        variant="contained"
        disabled={textValue.trim() === ""}
        className={classesNotes.sendButton}
        onClick={handleSubmitClicked}
        data-testid="send-button"
      >
        {"Submit"}
      </Button>
    </>
  );
};
